/** @format */

export interface MultipleProductsByEcodeParams {
  attributes?: boolean;
  skus?: boolean;
  active?: boolean;
  inventory?: boolean;
}
